module.exports = __webpack_public_path__ + "c57821b62440127c2773ebd25080b795.pdf";